import { Box, Button, Flex } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../core/hooks/storeHooks';
import { getSheetsInAGroup } from '../../../sheet/redux/sheetsManagerSlice';
import { switchActiveSheet } from '../../redux/windowsSlice';
import { TbSquareRoundedCheck } from 'react-icons/tb';

interface SheetStatusBarProps {
  groupId: string;
  sheetId: string;
  windowId: string;
}

interface SheetIdWithName {
  name: string;
  id: string;
}

const SheetStatusBar: React.FC<SheetStatusBarProps> = ({
  groupId,
  sheetId,
  windowId,
}) => {
  const dispatch = useAppDispatch();
  const sheets: SheetIdWithName[] = useAppSelector((state) =>
    getSheetsInAGroup(state, groupId)
  );

  const addSheet = () => {}
    // dispatch(
    //   addNewSheetToGroup({
    //     windowId: windowId,
    //     groupId: groupId,
    //   })
    // );

  const switchSheet = (sheetId: string) => {
    dispatch(
      switchActiveSheet({
        id: windowId,
        sheetId,
      })
    );
  };

  // TODO: Show stale icon or active icon
  return (
    <Box position="absolute" bottom="0px" width="100%" height="50px">
      <Flex>
        <Button ml="5px" variant={'outline'} onClick={addSheet}>
          +
        </Button>
        {sheets.map(({ name, id }) => {
          const isActive = id === sheetId;
          return (
            <Button
              isLoading={!name.length}
              px="5"
              py="3"
              borderRadius="10px"
              ml="5px"
              key={id}
              variant={isActive ? 'solid' : 'outline'}
              onClick={() => {
                !isActive && switchSheet(id);
              }}
              leftIcon={
                isActive ? <TbSquareRoundedCheck color="green" /> : undefined
              }
            >
              {name}
            </Button>
          );
        })}
      </Flex>
    </Box>
  );
};

export default SheetStatusBar;
